export default __webpack_public_path__ + "static/media/closet5-before3-768w.11e9cbd7.png";